import { render, staticRenderFns } from "./StandardClauseEdit.vue?vue&type=template&id=0de436ea&scoped=true&"
import script from "./StandardClauseEdit.vue?vue&type=script&lang=js&"
export * from "./StandardClauseEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de436ea",
  null
  
)

export default component.exports